// export const API_URL = "https://api-dev.motuum.com.br";
// export const API_URL = "https://devel.realweb.com.br:3002";
export const API_URL = "https://api.estacaodoolho.com.br";
// export const API_URL = "https://api.memovo.net.br";
export const REACT_APP_SECRET_KEY = "secret"
//export const REACT_APP_SITE_KEY = "6LcedpslAAAAAID6nXJk6evEzd6lfH-NYguOkzzr"
export const REACT_APP_SITE_KEY = "6Lc3y1knAAAAAGLhRO3XZHV1ZPkJLET-9otTCC6S"
export const WS_URL = "http://127.0.0.1:3010";
//export const WS_URL = "https://ws.memovo.net.br";